import React from 'react';
import styles from './NoItemsTile.module.scss';

const NoItemsTile = () => (
    <div className={styles.container}>
        <div id={'no-items-tile-alert'} className={styles.alert}>
            no results
        </div>
        <div
            id={'no-items-tile-call-to-action'}
            className={styles.callToAction}
        >
            please try a different combination of search parameters
        </div>
    </div>
);

export default NoItemsTile;
